//https://codepen.io/Iamafro/pen/bLqyGd
import  ks, { kObject, kObjectArray} from "../ReUsableTS/kalmstromShared4";
import { kStyleClass, kStyles } from "./kStyles";
export class kContextMenu{
    public MenuItems: kContentxtItems = new kContentxtItems();
    public Visible: boolean = false;
    public ShowMenu = (RightClickEvent:MouseEvent):void =>{
        if (ks.kErrorMode === true) { return ; }
        try {
            this.AddStyles();
            const MenuDiv:HTMLDivElement = this.MenuItems.ToDiv();
            MenuDiv.style.left = RightClickEvent.clientX +"px";
            MenuDiv.style.top = RightClickEvent.clientY +"px";
            const AllContextMenus:HTMLCollectionOf<Element> = document.getElementsByClassName("kContextMenu");
            let CurrMenu:HTMLDivElement;
            let Counter:number = 0;
            for(Counter = 0; Counter < AllContextMenus.length; Counter++){
                CurrMenu = AllContextMenus[Counter] as HTMLDivElement;
                CurrMenu.style.display = "none";
            }
            MenuDiv.style.display = "block"; 
            window.addEventListener("click", this.OutsideClick);
            RightClickEvent.preventDefault();
            RightClickEvent.stopPropagation();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContextMenu.ShowMenu");
        }
    }

    public AddMenuItem = (Title:string, ClickCB:any, Icon?:string):void =>{
        if (ks.kErrorMode === true) { return ; }
        try {
            const MenuItem:kContextMenuItem = new kContextMenuItem();
            MenuItem.Title = Title;
            MenuItem.ClickCB = ClickCB;
            MenuItem.Icon = Icon || "";
            this.MenuItems.Items.push(MenuItem);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContextMenu.AddMenuItem");
        }
    }
    public OutsideClick = ():void =>{
        if (ks.kErrorMode === true) { return ; }
        try {
            if(this.MenuItems.MenuDiv !== null){
                this.MenuItems.MenuDiv.style.display = "none";
            }
            window.removeEventListener("click", this.OutsideClick);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContextMenu.OutsideClick");
        }
    }
    public AddStyles = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const ExistingStyle = document.getElementById("kContextMenuStyles");
            if (ExistingStyle === null) {
                const Style = document.createElement('style');
                Style.id = "kContextMenuStyles";
                Style.innerHTML = `
                  .kContextMenu {
                    width: 160px;
                    z-index: 10000;
                    box-shadow: 0 4px 5px 3px rgba(0, 0, 0, 0.2);
                    position: fixed;
                    display: none;
                    transition: 0.2s display ease-in;
                    background-color: white;
                    font-family: Segoe UI,Tahoma,Helvetica,Arial,sans-serif !important;
                    font-size: 13px;
                  }
                  .kmenu-option:hover {
                    background-color: #f4f4f4;
                    font-weight: bold;
                  }
                  
                 `;
                document.head.appendChild(Style);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContextMenu.AddStyles");
            return;
        }

    }

}
export class kContentxtItems extends kObjectArray{
    public Items: kContextMenuItem[] = [];
    public MenuDiv: HTMLDivElement |null = null;
    public Clear = ():void =>{
        if (ks.kErrorMode === true) { return ; }
        try {
            let CurrItem:kContextMenuItem;
            for(CurrItem of this.Items){
                CurrItem.DivItem.remove();
            }
            this.Items = [];
        } catch (e) {ks.kGlobalErrorHandler(e, "kContentxtItems.Clear");return; }
    }
    public ToDiv = ():HTMLDivElement =>{
        if (ks.kErrorMode === true) { return document.createElement("div") ; }
        try {
            if(this.MenuDiv === null){
                this.MenuDiv = document.createElement("div");
                this.MenuDiv.className = "kContextMenu";
                document.body.appendChild(this.MenuDiv);
                let CurrItem:kContextMenuItem;
                for(CurrItem of this.Items){
                    this.MenuDiv.appendChild(CurrItem.ToDiv());
                }
            }
            return this.MenuDiv;

        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContentxtItems.ToDiv");
            return document.createElement("div")
        }
    }

}

export class kContextMenuItem extends kObject{
    public Icon: string = "";
    public ClickCB: any = null;
    public DivItem:HTMLDivElement = document.createElement("div");
    public ToDiv = ():HTMLDivElement =>{
        if (ks.kErrorMode === true) { return document.createElement("div"); }
        try {
            this.DivItem = document.createElement("div");
            this.DivItem.className = "kmenu-option";
            if(this.Icon !== ""){
                const IconSpan:HTMLSpanElement = document.createElement("span");
                const IconStyleClass:kStyleClass = kStyles.AddStyle("kContextMenu" +this.UniqueID.toString());
                if(IconStyleClass.New){
                    const IconStyle:CSSStyleDeclaration = IconStyleClass.Style;
                    IconStyle.width = "16px";  
                    IconStyle.height = "16px";
                    IconStyle.marginRight = "5px";
                    IconStyle.verticalAlign = "bottom";
                    IconStyle.cursor = "pointer";
                    IconStyle.backgroundImage = `url("${this.Icon}")`;
                    IconStyle.backgroundSize = "16px";
                    IconStyle.display = "inline-block";
                }
                IconStyleClass.Apply(IconSpan);
                //Icon.src = this.Icon;
                this.DivItem.appendChild(IconSpan);
                const Label:HTMLLabelElement = document.createElement("label");
                Label.textContent = this.Title;
                Label.style.cursor = "pointer";
                this.DivItem.appendChild(Label);
            }else{
                this.DivItem.textContent = this.Title;
            }
            const ContextMenuClass:kStyleClass = kStyles.AddStyle("kContextMenuItem");
            if(ContextMenuClass.Saved === false){
                ContextMenuClass.Style.padding = "5px 5px 5px 5px";
                ContextMenuClass.Style.cursor = "pointer";
            }
            ContextMenuClass.Apply(this.DivItem);
            this.DivItem.addEventListener("click", this._Click);
            return this.DivItem;
        } catch (e) {ks.kGlobalErrorHandler(e, "kContextMenuItem.ToDiv");return document.createElement("div");}
    }
    private _Click = (ObjectClicked: any):void =>{
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.ClickCB){
                this.ClickCB(this,ObjectClicked);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContextMenuItem._Click");
        }
    }
}
export class kContextMenuColorSwatch extends kObject{
    public Color: string = "";
    public Label: string = "";
    public ClickCB: any = null;
    public DivItem: HTMLDivElement = document.createElement("div");

    public ToDiv = (): HTMLDivElement => {
        if (ks.kErrorMode === true) { return document.createElement("div"); }
        try {
            this.DivItem = document.createElement("div");
            this.DivItem.className = "kmenu-color-swatch";
            this.DivItem.style.cssText = "display:inline-flex;align-items:center;gap:6px;padding:4px 8px;cursor:pointer;";
            const SwatchEl: HTMLSpanElement = document.createElement("span");
            SwatchEl.style.cssText = "width:16px;height:16px;border-radius:3px;border:1px solid rgba(0,0,0,0.15);display:inline-block;";
            if (this.Color !== "") {
                SwatchEl.style.background = this.Color;
            } else {
                SwatchEl.style.background = "transparent";
                SwatchEl.textContent = "\u2715";
                SwatchEl.style.textAlign = "center";
                SwatchEl.style.lineHeight = "16px";
                SwatchEl.style.fontSize = "10px";
                SwatchEl.style.color = "#999";
            }
            this.DivItem.appendChild(SwatchEl);
            if (this.Label !== "") {
                const LabelEl: HTMLSpanElement = document.createElement("span");
                LabelEl.textContent = this.Label;
                LabelEl.style.fontSize = "12px";
                this.DivItem.appendChild(LabelEl);
            }
            this.DivItem.addEventListener("click", this.OnSwatchClick);
            return this.DivItem;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContextMenuColorSwatch.ToDiv");
            return document.createElement("div");
        }
    };

    private OnSwatchClick = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (this.ClickCB) { this.ClickCB(this.Color); }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kContextMenuColorSwatch.OnSwatchClick");
        }
    };
}

//export class kContextMenuIcons{
    //public static Copy:string = "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";
    //public static Edit:string = "data:image/gif;base64,R0lGODlhEAAQAOZlAPT2/BYSDq1sXvb4/Ozw+bKaSff5/O7gjGp9kOzx+bO+0O3x+de/YvL1+2+BlfP2/PH0+rfC0/X4/Pj5/Zebl8rKyPD0+vDz+u3y+pido+vw+ZA1NcLL2e/y+unm3W1+kGp9kfT3/Pf4/Me3iJOjt+TT0X6OnuHe2eHe2nSGmdnCv9nEbKy4yuTi3bWgV/7+/fP1+9+PcKmTUYaGfY2espChtYmarmZ5i6WqqLnC0fL0+rvD0fj6/YqbrnyOooGTpniKnremZeLf17uwfXyLmgAAANGFc9B2Xuvv+YeWpfH1+46esuLf2mx/kvn6/fX3/IGSpvLm4nOGmWZ5jbOcTZSkuJGhtbmsc32PooaXq+LOdHiKnWp9j25xdYWWqmZ5jFFUV1lphO/z+u7y+rG9z////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAGUALAAAAAAQABAAAAfDgFUkNTQ2XlA+W1IOCAhTZWVWThMGA08PMEoWYh1jX5BLPJUSAA0QF2MYCwk3kD0TYWEAZLS0CQQJH5BZlQAPEGJjCwQaGhhJkD8GO2ENtWQKEWMlAgJlWCIhv8EESARjJwIxRwJAA7EWtNEcFUMsRgIbKQOlwQkLHShXByszG2UOJOQII2ZdhSAHGBQIACkgAB1ixFxg4iLhQgqQQDTi0sQEDioWA1AgAqlkyQwjtCw0yRJShhcyGLZk2QVMkZk4cQYCADs=";
    //public static Remove:string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAAABYktHRPg7Y2dmAAABh2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSfvu78nIGlkPSdXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQnPz4NCjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iPjxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+PHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9InV1aWQ6ZmFmNWJkZDUtYmEzZC0xMWRhLWFkMzEtZDMzZDc1MTgyZjFiIiB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+PHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj48L3JkZjpEZXNjcmlwdGlvbj48L3JkZjpSREY+PC94OnhtcG1ldGE+DQo8P3hwYWNrZXQgZW5kPSd3Jz8+LJSYCwAAAPNJREFUOE/N07tKA2EUBOAvXqIWmpgYEgTBVtDoC4j4ZuJDiXZpfAottfMGWiVibGbDZt2gpQPL/IczZ/7h7C71uMIbXsPXVUEZDfTQQR9HeMEZDnCa+jj9TvRLxfAGbrGH95hu4QlfEXZLvU084DzpNHCIR5xgEFE/g/3UAwyjGxYJCmzjLvFgbQG3o+umnrk0kwRaGGUXN+FRLhFdM+f5GEGx1BXshHulC+ZQZwBjTDEJj6uCAosM/oz/a7CapZW5FnUGUzzjs8LTqrCMAe5L73p9Abei2009SzBJcz9f23LqMrfTb0X/Axf5YT5+eS7LQ984rzDkW/CZsQAAAABJRU5ErkJggg==";
    //public static Paste:string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAABLElEQVQ4T63TT09TURAF8N+jsaAm0pTQSiTKDjYGNyxxYyDBxC/rQv0EbmSjKxamC2lCWQhpYsQS07I5r7k0L+iCk0zevPlzZu7MvTTjACOc43DR2YQOeujiBS5xlOQLbMXXS2xVJ1Z4hK94EH2MKbYTc4IWVvEbf7GXIvPqg7R9lu8O+nga/U3hG2Cj7KCDz3iH96k2RRvXkQqzxHzCa/wsCY5jvMJy7FXabqfYJPoHvMUPjEuC/bRZ4yG+pKNZbCt4gl+Zxa4QfC/PFfRxilfxbWQma3iJIbpLC0mLmITkLDLK2Yf4A/8iUMyg0fY/BHfiXgmuC73pvxE1wTI2M/lanuUuTBZylOT1W/gWsmkR1MrOb937YB0fsVe/qseZ7PyVFResaQtV1vj8BtlnO3nX4k0bAAAAAElFTkSuQmCC";
//}